import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: []
  }),
  actions: {
    addToast(message, type = 'success', duration = 3000) {
      const id = Date.now();
      this.toasts.push({ id, message, type, duration });

      if (duration > 0) {
        setTimeout(() => {
          this.removeToast(id);
        }, duration);
      }
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(toast => toast.id !== id);
    },
    success(message) {
      this.addToast(message, 'success');
    },
    error(message) {
      this.addToast(message, 'danger'); // Bootstrap uses 'danger' for errors
    },
    warning(message) {
      this.addToast(message, 'warning');
    }
  }
});
